export default "__VITE_ASSET__B3Qk2N00__"